import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'scenic-home-media',
  name: '景区banner',
  icon: '图',
  group: '景区主页',
  description: '景区顶部主视觉大图横幅。',
  defaultProps: {
    title: '景区主图',
    imageUrl: ''
  }
}
